import { crmmApi } from 'dashboard/helper/crmmApi';
export async function funilPost(path, body) {
  return crmmApi(path, body);
}
